import { useContext } from 'react';

import { DiscussionContext } from '../context/DiscussionContext';

export const useDiscussionContext = () => useContext(DiscussionContext);
